import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import LocationForm from '../components/forms/LocationForm';
import '../styles/EmployeeMaster.css';
import LocationTable from '../components/LocationTable';

const LocationEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [locationData, setLocationData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /sbu/edit
  const showModal = location.pathname.startsWith('/location/edit');

  const handleCloseModal = () => {
    navigate('/location'); // Go back to list
  };

  // ✅ Fetch SBU details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getLocationById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setLocationData(data.data);
          } else {
            setLocationData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching Location by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Location Master</h2>
      </div>

      {/* Table of SBUs */}
      <LocationTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : locationData ? (
            <LocationForm locationId={id} initialData={locationData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this Location.</p>
          )}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default LocationEditModel;
